import React from "react";
import Sjukrathjalfarar from "../../Json/sjukrathjalfarar.json";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Starfsfolk() {
	return (
		<div className="Body">
			<div className="TitleWButton">
				<h1>Starfsfólk</h1>
			</div>
			<div className="StarfsfolkGrid">
				{Sjukrathjalfarar.map((sjukrathjalfari, index) => {
					if (sjukrathjalfari.title !== "Sjúkraþjálfari") {
						return (
							<div key={sjukrathjalfari.id} className="StarfsfolkEach">
								<LazyLoadImage
									src={sjukrathjalfari.image}
									alt={sjukrathjalfari.name}
									className="StarfsfolkImgSize"
									effect="blur"
								/>
								<h2> {sjukrathjalfari.name} </h2>
								<p> {sjukrathjalfari.title} </p>
							</div>
						);
					}

					return (
						<Link
							to={`/starfsfolk/${sjukrathjalfari.id}`}
							key={sjukrathjalfari.id}
							className="StarfsfolkEach"
						>
							<LazyLoadImage
								src={sjukrathjalfari.image}
								alt={sjukrathjalfari.name}
								className="StarfsfolkImgSize"
								effect="blur"
							/>
							<h2> {sjukrathjalfari.name} </h2>
							<p> {sjukrathjalfari.title} </p>
						</Link>
					);
				})}
			</div>
		</div>
	);
}

export default Starfsfolk;
